// import { createBrowserHistory } from 'history';
// import { useNavigate } from 'react-router-dom';
// let history = createBrowserHistory()
// let snackBarRef = null

// const saveSnackbarRef = (ref) => {
//   snackBarRef = ref
// }

// const showSnackBar = ({ message, vertical, horizontal, severity, style }) => {
//   snackBarRef.setState({
//     open: true,
//     message: message || "success",
//     vertical: vertical || 'top',
//     horizontal: horizontal || 'center',
//     severity: severity || "success",
//     style
//   })
// }

// function camelCaseToTitle(text) {
//   var result = text.replace(/([A-Z])/g, " $1");
//   var finalResult = result.charAt(0).toUpperCase() + result.slice(1);
//   return finalResult
// }

// const numWithCommas = num =>
//   num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
// const AccountingFormat = (amount, currency = "") => {
//   if (amount < 0)
//     return `${currency}(${numWithCommas(
//       Number(Math.abs(amount))
//         .toFixed(2)
//         .replace("-", "")
//     )})`;
//   else
//     return `${currency}${numWithCommas(
//       Number(amount)
//         .toFixed(2)
//         .replace("-", "")
//     )}`;
// };

// const withRouter = (Component) => {
//   const Wrapper = (props) => {
//     const navigate = useNavigate();

//     return (
//       <Component
//         navigate={navigate}
//         {...props}
//         />
//     );
//   };

//   return Wrapper;
// };
// const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}))$/;

// export default {
//   history,
//   snackBarRef,
//   withRouter,
//   saveSnackbarRef,
//   showSnackBar,
//   emailRegex,
//   camelCaseToTitle,
//   AccountingFormat,
// }

// import { createBrowserHistory } from 'history';
import { useNavigate } from 'react-router-dom';

// The store, not the barrel: this module is imported by the axios interceptor
// and by the redux middlewares, and pulling in `components/` from there would
// drag the whole component tree into their import graph.
import { push as pushToast } from '../../components/Toast/toastStore';

// let history = createBrowserHistory()
// The `snackBarRef` / `saveSnackbarRef` / `showSnackBar` trio that used to live
// here is gone. It had no call sites left — `showMessage` below (antd `message`)
// superseded it — and it was broken in a way that could not work: the exported
// `Utils` object copied `snackBarRef` at module init, so it stayed null forever
// no matter what `saveSnackbarRef` assigned to the local binding.

/**
 * App-wide toast. Renders through `components/Toast` (bottom right); antd
 * `message` is no longer involved, and neither is the stack cap / duration
 * juggling that used to live here — both are the store's business now.
 *
 * The signature is unchanged, so every existing call site still works.
 *
 * @param status  'success' | 'error' | 'warning' | 'info' | 'loading'
 * @param content message text
 * @param options `{ key, duration, title }`. `duration` is in seconds; 0 pins
 *                the toast until it is dismissed (what `loading` defaults to).
 *                A stable `key` refreshes the existing toast rather than
 *                stacking another — though identical text now collapses into a
 *                repeat count whether a key was passed or not.
 * @returns a function that dismisses the toast it raised.
 */
const showMessage = (status, content, options = {}) => pushToast(status, content, options);

/**
 * The error in a socket acknowledgement, or `null` when the ack succeeded.
 *
 * Every `message:send` ack callback in the app read `item.response.*` straight
 * into a message row without looking at what kind of ack it was. The server
 * answers a refusal on the SAME callback (`{ response: { error, code },
 * event: 'message:error' }` — see denyAck in websocket/handlers.js), and its
 * sendMessage helper swallows its own exceptions and returns undefined, which
 * acks as `{ response: undefined }`. Both shapes turned into a row whose every
 * field was `undefined`: a blank bubble in the stream, no error anywhere, and a
 * message the sender believes was delivered.
 *
 * @returns {string|null} message to show the sender, or null if the ack is good
 */
const ackError = (ack) => {
  if (!ack || typeof ack !== 'object') return 'Message could not be sent';
  if (ack.event === 'message:error') return ack.response?.error || 'Message could not be sent';
  if (ack.response?.error) return ack.response.error;
  if (!ack.response) return 'Message could not be sent';
  return null;
};

function camelCaseToTitle(text) {
  var result = text.replace(/([A-Z])/g, ' $1');
  var finalResult = result.charAt(0).toUpperCase() + result.slice(1);
  return finalResult;
}

const numWithCommas = (num) => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
const AccountingFormat = (amount, currency = '') => {
  if (amount < 0)
    return `${currency}(${numWithCommas(Number(Math.abs(amount)).toFixed(2).replace('-', ''))})`;
  else return `${currency}${numWithCommas(Number(amount).toFixed(2).replace('-', ''))}`;
};

const withRouter = (Component) => {
  const Wrapper = (props) => {
    const navigate = useNavigate();

    return <Component navigate={navigate} {...props} />;
  };

  return Wrapper;
};
const emailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}))$/;

// format last seen date
export const formatLastSeen = (isoString) => {
  if (!isoString) return '';

  const date = new Date(isoString);
  // Same guard as formatListTime below. Without it a malformed timestamp reached
  // the conversation header and the details panel as the literal "Invalid Date".
  if (Number.isNaN(date.getTime())) return '';

  const formattedDate = date
    .toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    })
    .replace(',', ''); // => "17 Sep 2025"

  const formattedTime = date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });

  return `${formattedDate}, ${formattedTime}`;
};

/**
 * Compact timestamp for conversation list rows: "now", "12m", "3h",
 * "Yesterday", a weekday inside the last week, then a short date.
 */
export const formatListTime = (isoString) => {
  if (!isoString) return '';

  const date = new Date(isoString);
  if (Number.isNaN(date.getTime())) return '';

  const diffMinutes = Math.floor((Date.now() - date.getTime()) / 60000);
  if (diffMinutes < 1) return 'now';
  if (diffMinutes < 60) return `${diffMinutes}m`;

  const diffHours = Math.floor(diffMinutes / 60);
  if (diffHours < 24) return `${diffHours}h`;

  const diffDays = Math.floor(diffHours / 24);
  if (diffDays === 1) return 'Yesterday';
  if (diffDays < 7) return date.toLocaleDateString('en-GB', { weekday: 'short' });

  return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short' });
};

/* --------------------------------------------------------------------------
   Calendar days, for the day separators in a message stream

   These work in CALENDAR days in the reader's own timezone, not in elapsed
   hours. `formatListTime` above answers "how long ago", which is a different
   question and gives the wrong answer here: a message sent at 23:50 and read at
   00:10 is 20 minutes old but belongs under Yesterday, and one sent at 00:10
   read at 23:50 the same day is 23 hours old and still belongs under Today.

   Local, not UTC, and deliberately so despite the house rule: a separator names
   the day the reader lived through, so it has to turn over at their midnight.
   `toISOString().slice(0, 10)` would be a UTC day and would put the evening's
   messages under tomorrow for anyone east of Greenwich.
   -------------------------------------------------------------------------- */

/** Midnight local time on the day `date` falls in. */
const startOfLocalDay = (date) =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();

/** Whole calendar days from `date`'s day to today's. Negative if in the future. */
const calendarDaysAgo = (date) => {
  const MS_PER_DAY = 86400000;
  // Rounded because the span between two local midnights is 23 or 25 hours
  // across a DST boundary, which truncation would read as a day out.
  return Math.round((startOfLocalDay(new Date()) - startOfLocalDay(date)) / MS_PER_DAY);
};

/**
 * Label for a message stream's day separator: `Today`, `Yesterday`, a weekday
 * inside the last week, then a date — with the year only once it is not this
 * one, since "12 Mar" in a conversation you are scrolling reads as this year.
 */
export const formatDayDivider = (isoString) => {
  if (!isoString) return '';

  const date = new Date(isoString);
  if (Number.isNaN(date.getTime())) return '';

  const days = calendarDaysAgo(date);
  if (days === 0) return 'Today';
  if (days === 1) return 'Yesterday';
  // Only look back. A clock-skewed or genuinely future timestamp gets a date
  // rather than a weekday, which would otherwise read as one in the past.
  if (days > 1 && days < 7) return date.toLocaleDateString('en-GB', { weekday: 'long' });

  const sameYear = date.getFullYear() === new Date().getFullYear();
  return date.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    ...(sameYear ? {} : { year: 'numeric' }),
  });
};

/**
 * Last seen for a conversation header, which is one truncating line beside the
 * name. `formatLastSeen` always spells the date AND the year out ("17 Aug 2026,
 * 11:58 AM") — roughly 180px of text in a slot that is under 110px wide on a
 * 360px phone, so it wrapped, and a fixed-height header pushed the name out of
 * the band. This drops what the reader can infer: today keeps only the time
 * (the part that carries the information), the last week is a weekday, and
 * anything older is a date carrying the year only when it is not this one.
 *
 * Calendar days rather than elapsed hours, for the reason spelled out above
 * `startOfLocalDay` — 23:50 read at 00:10 is twenty minutes ago and still
 * "yesterday". The details panel keeps the long form; it has the room.
 */
export const formatLastSeenShort = (isoString) => {
  if (!isoString) return '';

  const date = new Date(isoString);
  if (Number.isNaN(date.getTime())) return '';

  const time = date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });

  const days = calendarDaysAgo(date);
  // `<= 0` rather than `=== 0`: a clock-skewed future timestamp reads as the
  // time of day, never as a weekday in the past.
  if (days <= 0) return time;
  if (days === 1) return `yesterday ${time}`;
  if (days < 7) return `${date.toLocaleDateString('en-GB', { weekday: 'short' })} ${time}`;

  const sameYear = date.getFullYear() === new Date().getFullYear();
  return date.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    ...(sameYear ? {} : { year: 'numeric' }),
  });
};

/**
 * The separator to render ABOVE a message, or `null` when it continues the day
 * the message before it was sent on.
 *
 * Boundary test and label in one call, because a stream that decided the two
 * separately could render a separator whose label matched the wrong message.
 * The first message in a stream always gets one — the day it opens on is as
 * worth naming as any later change.
 *
 * @param current  `createdAt` of the message about to be rendered
 * @param previous `createdAt` of the one before it, or undefined at the head
 */
export const dayDividerFor = (current, previous) => {
  const label = formatDayDivider(current);
  if (!label) return null;
  if (!previous) return label;

  const previousDate = new Date(previous);
  // An unreadable neighbour cannot establish a day, so it cannot suppress a
  // separator either — better a repeated label than a stream with none.
  if (Number.isNaN(previousDate.getTime())) return label;

  return startOfLocalDay(new Date(current)) === startOfLocalDay(previousDate) ? null : label;
};

const Utils = {
  withRouter,
  emailRegex,
  camelCaseToTitle,
  AccountingFormat,
  showMessage,
  ackError,
};

export default Utils;
